/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description EditPayerDetails Button
 */
import { Button as AntButton, ButtonProps, Tooltip } from 'antd';
import { SettingTwo } from '@icon-park/react';

import { Link } from 'react-router-dom';
import { getEditPayerDetailsPath } from 'utils/router';
import { useAppStoreValues } from 'store/app';
import { NO_ACCESS_TOOLTIP_TEXT } from '@veritable/common/constants';

/**
 * EditPayerDetails
 *
 */

const EditPayerDetailsLink: React.FC<ILinkProps> = (props) => {
	const { children, id, ...restProps } = props;

	return (
		<Link {...restProps} to={getEditPayerDetailsPath(id)}>
			{children}
		</Link>
	);
};

const EditPayerDetails: React.FC<Record<'tenantPayerID', string> & ButtonProps> = ({ tenantPayerID, ...restProps }) => {
	const { canUpdatePayers } = useAppStoreValues().userAccess;
	const editButton = (
		<Tooltip title={`${canUpdatePayers ? 'Configure' : NO_ACCESS_TOOLTIP_TEXT}`}>
			<AntButton color='default' icon={<SettingTwo />} {...restProps} disabled={!canUpdatePayers} />
		</Tooltip>
	);

	if (tenantPayerID && canUpdatePayers) {
		return (
			<EditPayerDetailsLink key='edit-payer' id={tenantPayerID}>
				{editButton}
			</EditPayerDetailsLink>
		);
	}

	return editButton;
};

export default EditPayerDetails;
export { EditPayerDetailsLink };
